import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { useEffect } from 'react';

import { 
    Paper, 
    Stack, 
    Typography, 
    Autocomplete, 
    TextField, 
    Box 
} from '@mui/material';

import { Encabezado } from '../../Components/Encabezado/Encabezado'
import Select from "react-select";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";


import SaveIcon from '@mui/icons-material/Save';
import Loading from '../../Components/Modals/Loading/Loader';

import { selectUserData } from '../../redux/Login/LoginSlice';

import { 
    fetchAreasOrganizacionales, 
    selectAllAreasOrganizacionales 
} from '../../redux/AreaOrganizacional/AreaOrganizacionalSlice';

import { 
    selectIsLoading, 
    selectIsSuccess, 
    selectMessage,
    fetchCambiarSuccess,
    fetchInsertOrUpdate
} from '../../redux/ControlMensajeria/ControlMensajerioSlice';

import swal from 'sweetalert';

export const SolicitudEmpleado = () => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-SELECTOR
    const listAreaOrganizacionales = useSelector(selectAllAreasOrganizacionales);
    const usuario = useSelector(selectUserData);
    const isLoading = useSelector(selectIsLoading);
    const success = useSelector(selectIsSuccess);
    const message = useSelector(selectMessage);

    // * FORMATO DE LA ESTRUCTURA DEL OBJETO A ENVIAR A BD.
    const formSchema = Yup.object().shape({
        controlMensajeria: Yup.object().shape({
            id: Yup.number(),
            areaOrganizacionalId: Yup.number().required("El campo es requerido").notOneOf([0], "Debe seleccionar una opción válida"),
            extension: Yup.number().required("El campo es requerido")
                                    .transform((value, originalValue) => (originalValue === "" ? NaN : value)) // Evita que "" se convierta en NaN automáticamente
                                    .typeError("Debe ingresar un número válido") // Si no es un número, muestra este mensaje
                                    .notOneOf([0], "El valor no puede ser 0, favor ingresar un número válido."),
            motivo: Yup.string().required("El campo es requerido").min(5, 'El motivo es muy corto favor detallar su solicitud'),
            observaciones: Yup.string().nullable(),
            estadoId: Yup.number().required("El campo es requerido"),
            usuarioSolicitante: Yup.number().required("El campo es requerido").notOneOf([0], "Debe seleccionar una opción válida"),
            usuarioMensajero: Yup.number().nullable(),
            fechaCreacion: Yup.date().nullable(),
            departamentosRecepcion: Yup.array().nonNullable().of(Yup.number()).min(1, 'Debes seleccionar al menos una opción')
        })
    });

    // ? HOOK-FORM
    const { 
        control,
        formState: { errors },
        setValue,
        register,
        handleSubmit,
        reset
    } = useForm({
        defaultValues: {
            controlMensajeria: {
            id: 0,
            usuarioSolicitante: 0,
            areaOrganizacionalId: 0,
            usuarioMensajero: null,
            extension: null,
            estadoId: 1,
            motivo: "",
            observaciones: null,
            fechaCreacion: null,
            departamentosRecepcion: []
            }
        },
        resolver: yupResolver(formSchema)
    })

    // ? USE-EFFECT
    useEffect(() => {
        dispatch(fetchAreasOrganizacionales());
    }, [])

    useEffect(() => {
      if(Object.keys(usuario).length > 0){
        setValue('controlMensajeria.areaOrganizacionalId', usuario?.AreaPadreId ? parseInt(usuario?.AreaPadreId) : parseInt(usuario?.AreaOrganizacionalId));
        setValue('controlMensajeria.usuarioSolicitante', usuario?.Id);
      }
    }, [usuario])

    useEffect(() => {
    
        if(success === 'success' && message.length > 0){
            dispatch(fetchCambiarSuccess());
            swal("Exitoso!", message, "success");
            reset();
        }
        else if(success ==='error'){
            swal("Error!", message, "error");
        }
         
    }, [success, message]);
    
    // * ENVIAR DATOS.
    const onSubmit = ({ controlMensajeria }) => {
        dispatch(fetchInsertOrUpdate(controlMensajeria));
    }

  return (
    <Encabezado title="Solicitud de Mensajería">
        <Paper sx={{width: '50%'}}>
            <Stack m={2} component='form' onSubmit={handleSubmit(onSubmit)}>
                 <Stack>
                        <Typography fontSize='12px' fontWeight='bold'>Departamento</Typography>
                        <Controller
                            control={control}
                            name="controlMensajeria.areaOrganizacionalId"
                            rules={{
                                required: "El campo es requerido",
                                validate: value => value !== 0 || 'El campo es requerido',
                            }}
                            render={({ field }) => (
                                <Select
                                id='select-area'
                                classNamePrefix="select"
                                isSearchable={true}
                                placeholder="Seleccionar Área"
                                options={listAreaOrganizacionales}
                                getOptionLabel={(option) => option.nombre}
                                getOptionValue={(option) => option.id}
                                onChange={(e) => field.onChange(e.id)}
                                value={listAreaOrganizacionales.find(x => x.id === field.value)}
                                />
                        )}
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.areaOrganizacionalId?.message}>
                            {errors.controlMensajeria?.areaOrganizacionalId?.message}
                        </Typography>
                    </Stack>

                    <Stack mt={1}>
                        <Typography fontSize='12px' fontWeight='bold'>Departamentos Involucrados</Typography>
                        <Controller
                        name="controlMensajeria.departamentosRecepcion"
                        control={control}
                        defaultValue={[]}
                        rules={{ required: 'Este campo es obligatorio' }} // Validaciones
                        render={({ field }) => (
                            <Autocomplete
                                {...field}
                                id="periodo"
                                multiple
                                disablePortal
                                disableClearable
                                getOptionLabel={(areas) => areas.nombre}
                                options={listAreaOrganizacionales}
                                isOptionEqualToValue={(option, value) => option.id === value}
                                noOptionsText="No encontrado"
                                renderOption={(props, areas) => (
                                    <Box component="option" {...props} key={areas.id} value={areas.id}>
                                        {areas.nombre}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField 
                                        {...params} 
                                        label="" 
                                    />
                                )}
                                onChange={(event, newValue) => {
                                    // `newValue` es un array de objetos completos (con `id` y `nombre`)
                                    // Aquí solo guardamos los ids seleccionados
                                    const selectedIds = newValue.map(areas => areas.id);
                                    field.onChange(selectedIds); // Actualiza el valor en el formulario solo con los ids
                                }}
                                value={listAreaOrganizacionales.filter(area => 
                                    field.value.includes(area.id)
                                )}
                            />
                        )}
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.departamentosRecepcion}>
                            {errors?.controlMensajeria?.departamentosRecepcion?.message}
                        </Typography>

                    </Stack>

                    <Stack mt={1}>
                        <Typography fontSize='12px' fontWeight='bold'>Extensión</Typography>
                        <input 
                        {...register('controlMensajeria.extension', {
                            required: "El campo es requerido"
                        })}
                        className='form-control' 
                        type='number' 
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.extension?.message}>
                            {errors.controlMensajeria?.extension?.message}
                        </Typography>
                    </Stack>

                    <Stack mt={1}>
                        <Typography fontSize='12px' fontWeight='bold'>Motivo</Typography>
                        <input 
                        {...register('controlMensajeria.motivo', {
                            required: "El campo es requerido"
                        })}
                        className='form-control' 
                        type='text' 
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.motivo?.message}>
                            {errors.controlMensajeria?.motivo?.message}
                        </Typography>
                    </Stack>

                    <div className='mt-2 d-flex justify-content-end'>
                        <button 
                        type='submit'
                        className='btn btn-primary-mem mb-2'
                        >
                            SOLICITAR
                            <SaveIcon sx={{marginTop: -0.5, marginLeft: 0.5}} />
                        </button>
                    </div>
            </Stack>
        </Paper>

        <Loading open={isLoading} />
    </Encabezado>
  )
}
